import { render, staticRenderFns } from "./FriendsList.vue?vue&type=template&id=60597544&scoped=true&"
import script from "./FriendsList.vue?vue&type=script&lang=js&"
export * from "./FriendsList.vue?vue&type=script&lang=js&"
import style0 from "./FriendsList.vue?vue&type=style&index=0&id=60597544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60597544",
  null
  
)

export default component.exports